/* eslint-disable indent */
import React, {
  Suspense, useEffect, cloneElement, useContext} from 'react';
import { Provider } from 'react-redux';
import {
  Loader, usePermission, AppContext, idpPath, IDP, Logout as LogOut, Login as LogIn
} from '@ctsu/loader';
import {
  Navigate, Route, Routes, BrowserRouter, useNavigate
} from 'react-router-dom';
import { GoogleAnalytics } from '@ctsu/react-ctsu-ui';
import { indexRoutes } from './routes/appRoutes';
import Layout from './components/Layout/Layout';
import CTSUErrorBoundary from './components/ErrorBoundary';
import Confirmation from './components/Confirmation/Confirmation';
import { Permission } from './components/CustomComponents';
import { store, history } from './stores/store';
import { getGAId } from './helpers';
import LoginHolder from './components/Layout/LoginHolder';

function Login() {
  return (
    <LoginHolder>
      <LogIn page={<Navigate to="/packet/browser" />} width="100%" />
    </LoginHolder>
  );
}

function Loading() {
  return <div>...Loading</div>;
}
function Logout() {
  return <LogOut logout={<Navigate to="/login" />} />;
}

let flatRoutes = [];
indexRoutes.forEach((route) => {
  flatRoutes.push(route);
  if (route.subRoutes) {
    flatRoutes = [...flatRoutes, ...route.subRoutes];
  }
});

export const useRegulatoryPermission = permission => usePermission(permission);

function GotoLogin() {
  return <Navigate to="/login" />;
}

function Refresh() {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => navigate(-1), 20);
  }, [navigate]);
  return null;
}

function Protect() {
  const context = useContext(AppContext);
  const { session } = context;
  const authenticated = session && session.username;
  if (authenticated) {
    return <Permission />;
  }
  return <GotoLogin />;
}

function ProtectedRoute({
  permission, element, ...props
}) {
  const hasPermit = useRegulatoryPermission(permission);
  if (hasPermit) {
    return (
      <CTSUErrorBoundary {...props}>
        <>{cloneElement(element, { ...props })}</>
      </CTSUErrorBoundary>
    );
  }

  return (
    <Protect />
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <Suspense fallback={<main>Loading...</main>}>
        <Loader loadIndicator={<Loading />}>
          <Confirmation />
          <BrowserRouter history={history}>
            <Layout>
              <Routes>
                {flatRoutes.map(({
                  path, isExact, hasPermit, permission, element
                }) => (
                  <Route
                    key={path}
                    exact={isExact}
                    path={path}
                    // eslint-disable-next-line object-curly-newline
                    element={<ProtectedRoute {...{ hasPermit, permission, element }} />}
                  />
                ))}
                <Route path="/refresh" element={<Refresh />} />
                <Route path={idpPath} element={<IDP />} />
                <Route exact path="/logout" element={<Logout />} />
                <Route path="/login" element={<Login />} />
                <Route path="" element={<Navigate to="/login" />} />
              </Routes>
            </Layout>
            <GoogleAnalytics application={process.env.REACT_APP_NAME} gaTrackingId={getGAId()} />
          </BrowserRouter>
        </Loader>
      </Suspense>
    </Provider>
  );
}
